/**
 * Curriculum Planner API — KCIS Admin only.
 * All routes are under /api/kcis/admin/curriculum/*.
 */
import { api } from "@/lib/api";

const BASE = "/kcis/admin/curriculum";

export const curriculumApi = {
  // Enums
  enums: async () => (await api.get(`${BASE}/enums`)).data,

  // Programs
  listPrograms: async (params = {}) =>
    (await api.get(`${BASE}/programs`, { params })).data,
  getProgram: async (id) => (await api.get(`${BASE}/programs/${id}`)).data,
  createProgram: async (body) => (await api.post(`${BASE}/programs`, body)).data,
  patchProgram: async (id, body) => (await api.patch(`${BASE}/programs/${id}`, body)).data,
  retireProgram: async (id) => (await api.delete(`${BASE}/programs/${id}`)).data,

  // Planned courses
  listPlannedCourses: async (params = {}) =>
    (await api.get(`${BASE}/planned-courses`, { params })).data,
  createPlannedCourse: async (body) =>
    (await api.post(`${BASE}/planned-courses`, body)).data,
  patchPlannedCourse: async (id, body) =>
    (await api.patch(`${BASE}/planned-courses/${id}`, body)).data,
  deletePlannedCourse: async (id) =>
    (await api.delete(`${BASE}/planned-courses/${id}`)).data,
  bulkImport: async (body) =>
    (await api.post(`${BASE}/planned-courses/bulk-import`, body)).data,

  // Competencies
  listCompetencies: async (params = {}) =>
    (await api.get(`${BASE}/competencies`, { params })).data,
  createCompetency: async (body) =>
    (await api.post(`${BASE}/competencies`, body)).data,
  patchCompetency: async (id, body) =>
    (await api.patch(`${BASE}/competencies/${id}`, body)).data,
  deleteCompetency: async (id) =>
    (await api.delete(`${BASE}/competencies/${id}`)).data,

  // KAPE bridge
  buildInKape: async (body) => (await api.post(`${BASE}/build-in-kape`, body)).data,
  syncFromKape: async (pcId) =>
    (await api.post(`${BASE}/planned-courses/${pcId}/sync-from-kape`)).data,
  unlinkKape: async (pcId) =>
    (await api.post(`${BASE}/planned-courses/${pcId}/unlink-kape`)).data,

  // Dashboards & warnings
  programProgress: async (programId) =>
    (await api.get(`${BASE}/programs/${programId}/progress`)).data,
  executiveDashboard: async (params = {}) =>
    (await api.get(`${BASE}/executive-dashboard`, { params })).data,
  dependencyWarnings: async (programId) =>
    (await api.get(`${BASE}/programs/${programId}/dependency-warnings`)).data,
};

// Human labels for status enums
export const PLANNER_STATUS_LABEL = {
  planned: "Planned",
  in_development: "In Development",
  ready: "Ready",
  active: "Active",
  retired: "Retired",
};

export const PLANNER_STATUS_COLOR = {
  planned: "#6B7280",
  in_development: "#F59E0B",
  ready: "#22D3EE",
  active: "#10B981",
  retired: "#4B5563",
};

export const KAPE_STATUS_LABEL = {
  "": "—",
  draft: "Draft",
  blueprint_ready: "Blueprint Ready",
  modules_ready: "Modules Ready",
  assessments_ready: "Assessments Ready",
  review: "In Review",
  ready_to_publish: "Ready to Publish",
  published: "Published",
  archived: "Archived",
};
